export default "__VITE_ASSET__5c87104a__"